import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import katex from 'katex';

import { AppModule } from './app/app.module';

(window as any).katex = katex;

platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true
})
  .catch(err => console.error(err));
